import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/Banner/university.webp";
import shield from "../../Images/icons/shield.svg";
import isbmshield from "../../Images/about/shield.webp";
import torch from "../../Images/icons/olympic-flame.svg";
import quill from "../../Images/icons/inkwell.svg";
import trophy from "../../Images/icons/award.svg";
import globe from "../../Images/icons/earth.svg";

import icon1 from "../../Images/campus/campusIcon1.webp";
import icon2 from "../../Images/campus/campusIcon2.webp";
import icon3 from "../../Images/campus/campusIcon3.webp";
import icon4 from "../../Images/campus/campusIcon4.webp";
import icon5 from "../../Images/campus/campusIcon5.webp";
import icon6 from "../../Images/campus/campusIcon6.webp";
import icon7 from "../../Images/campus/campusIcon7.webp";
import icon8 from "../../Images/campus/campusIcon8.webp";
import icon9 from "../../Images/campus/campusIcon9.webp";
import icon10 from "../../Images/campus/campusIcon10.webp";
import icon11 from "../../Images/campus/campusIcon11.webp";
import icon12 from "../../Images/campus/campusIcon12.webp";
import icon13 from "../../Images/campus/campusIcon13.webp";
import icon14 from "../../Images/campus/campusIcon14.webp";
import icon15 from "../../Images/campus/campusIcon15.webp";
import icon16 from "../../Images/campus/campusIcon16.webp";

import pic1 from "../../Images/campus/campus-1.webp";
import pic2 from "../../Images/campus/campus-2.webp";
import pic3 from "../../Images/campus/campus-3.webp";
import pic4 from "../../Images/campus/campus-4.webp";
import pic5 from "../../Images/campus/campus-5.webp";
import pic6 from "../../Images/campus/campus-6.webp";
import pic7 from "../../Images/campus/campus-7.webp";
import pic8 from "../../Images/campus/campus-8.webp";
import pic9 from "../../Images/campus/campus-9.webp";
import pic10 from "../../Images/campus/campus-10.webp";
import pic11 from "../../Images/campus/campus-11.webp";
import pic12 from "../../Images/campus/campus-12.webp";
import pic13 from "../../Images/campus/campus-13.webp";
import pic14 from "../../Images/campus/campus-14.webp";

import acdpic1 from "../../Images/campus/lib-1.webp";
import acdpic2 from "../../Images/campus/library-1.webp";
import acdpic3 from "../../Images/campus/campus-15.webp";
import acdpic4 from "../../Images/campus/reading-room-2.webp";

import labpic1 from "../../Images/campus/lab-1.webp";
import labpic2 from "../../Images/campus/lab-2.webp";
import labpic3 from "../../Images/campus/lab-3.webp";
import labpic4 from "../../Images/campus/lab-4.webp";
import labpic5 from "../../Images/campus/lab-5.webp";
import labpic6 from "../../Images/campus/lab-6.webp";
import labpic7 from "../../Images/campus/lab-7.webp";
import labpic8 from "../../Images/campus/lab-8.webp";
import labpic9 from "../../Images/campus/lab-9.webp";
import labpic10 from "../../Images/campus/lab-10.webp";
import labpic11 from "../../Images/campus/lab-11.webp";
import labpic12 from "../../Images/campus/lab-12.webp";

import sportspic1 from "../../Images/sports/sports-1.webp";
import sportspic2 from "../../Images/sports/sports-2.webp";
import sportspic3 from "../../Images/sports/sports-3.webp";
import sportspic4 from "../../Images/sports/sports-4.webp";
import sportspic5 from "../../Images/sports/sports-5.webp";
import sportspic6 from "../../Images/sports/sports-6.webp";
import sportspic7 from "../../Images/sports/sports-7.webp";
import sportspic8 from "../../Images/sports/sports-8.webp";
import sportspic9 from "../../Images/sports/sports-9.webp";
import sportspic10 from "../../Images/sports/sports-10.webp";
import sportspic11 from "../../Images/sports/sports-11.webp";
import sportspic12 from "../../Images/sports/sports-12.webp";

import hostelpic1 from "../../Images/campus/hostel-1.webp";
import hostelpic2 from "../../Images/campus/hostel-2.webp";
import hostelpic3 from "../../Images/campus/hostel-3.webp";
import hostelpic4 from "../../Images/campus/hostel-4.webp";
import hostelpic5 from "../../Images/campus/hostel-5.webp";
import hostelpic6 from "../../Images/campus/canteen-1.webp";
import hostelpic7 from "../../Images/campus/hostel-6.webp";
import hostelpic8 from "../../Images/campus/reading-room-1.webp";

import workshopspic1 from "../../Images/campus/workshop-1.webp";
import workshopspic2 from "../../Images/campus/workshop-2.webp";
import workshopspic3 from "../../Images/campus/workshop-3.webp";
import workshopspic4 from "../../Images/campus/workshop-4.webp";
import workshopspic5 from "../../Images/campus/workshop-5.webp";
import workshopspic6 from "../../Images/campus/workshop-6.webp";
import workshopspic7 from "../../Images/campus/workshop-7.webp";
import workshopspic8 from "../../Images/campus/workshop-8.webp";

const AboutUs = () => {
  const handleTouchStart = (e) => {
    e.currentTarget.classList.toggle("hover");
  };

  const icons = [
    icon1,
    icon2,
    icon10,
    icon5,
    icon6,
    icon11,
    icon7,
    icon3,
    icon4,
    icon8,
    icon9,
    icon12,
    icon13,
    icon14,
    icon15,
    icon16,
  ];
  const campusItems = [
    "Green Campus",
    "Wi-Fi Campus",
    "Cafeteria",
    "Sports Facilities",
    "Temple",
    "Workshops",
    "Recreation Rooms",
    "Lush & Green Surroundings",
    "Apt Learning Environment",
    "Seminar Halls",
    "Girls & Boys Hostels",
    "Well stocked Library",
    "Digital Library",
    "Music Room",
    "Moot Court",
    "Laboratories",
  ];
  return (
    <>
      <title>About ISBM University | Vision, Mission & Excellence.</title>
      <meta
        name="description"
        content="ISBM University is one of the best university for affordable academic excellence for diploma & masters programs empowering students through quality education."
      />
      <meta
        name="keywords"
        content="ISBM University Chhattisgarh, Best university in chhattisgarh, ISBM university raipur"
      />


      <meta
        name="SearchEngines"
        content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
      />
      <meta name="Robots" content="INDEX, FOLLOW" />
      <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
      <meta name="Robots" content="INDEX,ALL" />
      <meta name="YahooSeeker" content="INDEX, FOLLOW" />
      <meta name="msnbot" content="INDEX, FOLLOW" />
      <meta name="googlebot" content="Default, follow" />
      <meta name="owner" content="isbmuniversity.edu.in/" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="2 days" />
      <meta
        property="og:title"
        content="ISBM University Empowering Through Affordable Education"
      />
      <meta
        property="og:description"
        content="ISBM University is one of the best university for affordable academic excellence for diploma & masters programs empowering students through quality education."
      />
      <meta
        property="og:url"
        content="https://isbmuniversity.edu.in/about-us/"
      />
      <meta
        property="og:image"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta property="og:image:alt" content="ISBM University" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ISBM University" />
      <meta
        name="twitter:title"
        content="ISBM University Empowering Through Affordable Education"
      />
      <meta
        name="twitter:description"
        content="ISBM University is one of the best university for affordable academic excellence for diploma & masters programs empowering students through quality education."
      />
      <meta
        name="twitter:image:src"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ISBMUniversity" />
      <meta name="twitter:creator" content="@ISBMUniversity" />
      <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
      <meta property="twitter:account_id" content="758619542734053376" />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>The Story Behind the Vision</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  About Us
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="ptb-50">
        <div className="container-xxl">
          <Row className="m-0">
            <div className="col-md-6 mt-5 d-flex justify-content-center">
              <div className="image-wrapper position-relative mb-lg-5">
                <div className="image-bg h-75"></div>
                <img
                  src={bannerImage}
                  className="img-fluid rounded placement-image position-relative"
                  alt="Placement Classroom"
                />
              </div>
            </div>
            <Col lg={6}>
              <h2 className="section-title-start modern-title">
                A Legacy of Learning and Excellence
              </h2>
              <p className="fw-bold text-purple">
                The University is established and approved by the Government of
                Chhattisgarh under the Chhattisgarh Private Universities
                (Establishment and Operation) Act, 2005 (Amendment Act 2016) to
                confer Certificate Diploma, PG Diploma, Degree and Doctorate
                Degree to the students.
              </p>
              <p>
                ISBM University programmes are research driven, skill based and
                knowledge intensive. The University is a centre of academic
                innovation and research where students and faculty collaborate
                to learn, research, create, innovate, inspire and incubate.
              </p>
              <p>
                ISBM University endeavors to offer services across the student's
                life cycle not only supported by teaching and learning but also
                with career development, skill enhancement, employment
                opportunities, business, incubation and fund raising for
                development initiatives. It is committed to prepare its students
                to face the challenges of new age society. It also strives to
                improve the quality of employment of the people by academic
                interventions.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      {/* Our Identity */}
      <section className="ptb-50 bg-blue">
        <div className="container-xxl">
          <h2 className="section-title text-center modern-title text-white">
            Our Identity
          </h2>
          <h6 className="modern-subtitle text-white text-center">
            A vibrant learning ecosystem where knowledge, skills, and values
            align to create impactful careers
          </h6>

          <div className="diagram d-lg-block d-none">
            <svg viewBox="0 -1 33 32">
              <circle r="16" cx="100" cy="16" />
              <path
                d="M16 16 L16 0 A16 16 0 0 1 30.5 9.3 Z"
                fill="#fecc00"
                stroke="#fff"
                stroke-width="0.5"
                stroke-linejoin="round"
              />

              <path
                d="M16 16 L30.5 9.3 A16 16 0 0 1 25.9 27.5 Z"
                fill="#fecc00"
                stroke="#fff"
                stroke-width="0.5"
                stroke-linejoin="round"
              />

              <path
                d="M16 16 L25.9 27.5 A16 16 0 0 1 6.1 27.5 Z"
                fill="#fecc00"
                stroke="#fff"
                stroke-width="0.5"
                stroke-linejoin="round"
              />

              <path
                d="M16 16 L6.1 27.5 A16 16 0 0 1 1.5 9.3 Z"
                fill="#fecc00"
                stroke="#fff"
                stroke-width="0.5"
                stroke-linejoin="round"
              />

              <path
                d="M16 16 L1.5 9.3 A16 16 0 0 1 16 0 Z"
                fill="#fecc00"
                stroke="#fff"
                stroke-width="0.5"
                stroke-linejoin="round"
              />
            </svg>

            <div className="isbmshield">
              <img src={isbmshield} alt="Shield 1" />
            </div>

            <div className="icon icon1">
              <img src={shield} alt="Shield 1" />
            </div>
            <div className="icon icon2">
              <img src={quill} alt="Shield 3" />
            </div>
            <div className="icon icon3">
              <img src={globe} alt="Shield 5" />
            </div>
            <div className="icon icon4">
              <img src={trophy} alt="Shield 4" />
            </div>
            <div className="icon icon5">
              <img src={torch} alt="Shield 2" />
            </div>

            <div className="desc-box shadow-lg desc1">
              <h3>Resilience & Security</h3>
              <p>
                The shield represents resilience, security, and a strong
                foundation for achieving academic and personal goals.
              </p>
            </div>
            <div className="desc-box shadow-lg desc2">
              <h3>Tradition in Communication</h3>
              <p>
                The quill represents the rich heritage of written communication
                through the historic use of feather pens.
              </p>
            </div>
            <div className="desc-box shadow-lg desc3">
              <h3>Global Perspective</h3>
              <p>
                The globe illustrates the university’s focus on global exposure
                and international opportunities.
              </p>
            </div>
            <div className="desc-box shadow-lg desc4">
              <h3>Commitment to Excellence</h3>
              <p>
                The trophy stands for recognition of excellence, celebrating
                achievements and milestones.
              </p>
            </div>
            <div className="desc-box shadow-lg desc5">
              <h3>Pursuit of Wisdom</h3>
              <p>
                It represents enlightenment, wisdom, and the pursuit of
                knowledge that dispels ignorance.
              </p>
            </div>
          </div>

          {/* </div> */}
          <div className="mob-diagram d-lg-none d-block">
            <Row className="m-0">
              <Col className="p-3" md={"6"}>
                <div className="identity-box">
                  <div className="identity-icon">
                    <img src={shield} alt="Shield 1" />
                  </div>
                  <h3>Resilience & Security</h3>
                  <h6>
                    The shield represents resilience, security, and a strong
                    foundation for achieving academic and personal goals.
                  </h6>
                  <div className="hover-content d-none">
                    <p>
                      <small>
                        <b>Connection: </b>This icon underscores ISBM
                        University’s commitment to providing a supportive and
                        secure environment that fosters growth, excellence, and
                        the protection of community values and achievements.
                      </small>
                    </p>
                  </div>
                </div>
              </Col>
              <Col className="p-3" md={"6"}>
                <div className="identity-box">
                  <div className="identity-icon">
                    <img src={torch} alt="Shield 1" />
                  </div>
                  <h3> Pursuit of Wisdom</h3>
                  <h6>
                    The torch symbolizes enlightenment, wisdom, and the pursuit
                    of knowledge that dispels ignorance.
                  </h6>
                  <div className="hover-content d-none">
                    <p>
                      <small>
                        <b>Connection: </b>It reflects the university’s role in
                        guiding students toward success and inspiring continuous
                        progress and excellence.
                      </small>
                    </p>
                  </div>
                </div>
              </Col>
              <Col className="p-3" md={"6"}>
                <div className="identity-box">
                  <div className="identity-icon">
                    <img src={quill} alt="Shield 1" />
                  </div>
                  <h3>Tradition in Communication</h3>
                  <h6>
                    The quill represents the rich heritage of written
                    communication through the historic use of feather pens.
                  </h6>
                  <div className="hover-content d-none">
                    <p>
                      <small>
                        <b>Connection: </b>It shows the university’s
                        appreciation for educational evolution, connecting
                        tradition with modern learning practices.
                      </small>
                    </p>
                  </div>
                </div>
              </Col>
              <Col className="p-3" md={"6"}>
                <div className="identity-box">
                  <div className="identity-icon">
                    <img src={trophy} alt="Shield 1" />
                  </div>
                  <h3>Commitment to Excellence</h3>
                  <h6>
                    The trophy stands for recognition of excellence, celebrating
                    achievements and milestones.
                  </h6>
                  <div className="hover-content d-none">
                    <p>
                      <small>
                        <b>Connection: </b>This highlights the university’s
                        dedication to rewarding outstanding academic and
                        professional performance.
                      </small>
                    </p>
                  </div>
                </div>
              </Col>
              <Col className="p-3" md={"6"}>
                <div className="identity-box">
                  <div className="identity-icon">
                    <img src={globe} alt="Shield 1" />
                  </div>
                  <h3> Global Perspective</h3>
                  <h6>
                    The globe illustrates the university’s focus on global
                    exposure and international opportunities.
                  </h6>
                  <div className="hover-content d-none">
                    <p>
                      <small>
                        <b>Connection: </b>
                      </small>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>

      {/* Why Choose us */}
      <section className="ptb-50">
        <div className="container-xxl">
          <h2 className="section-title-start modern-title">
            Why Choose ISBM University?
          </h2>
          <h6 className="modern-subtitle">
            At ISBM University, we are committed to developing leaders who are
            not merely skilled professionals but also compassionate people with
            strong ethical values.
          </h6>
          <div className="row m-0 row-cols-lg-3 row-cols-md-3 row-cols-2 reason-container">
            <Col>
              <div className="reason-box">
                <div className="reason-title">Global Recognition</div>
                <p className="reason-desc">
                  NAAC accredited and member of international bodies.
                </p>
              </div>
            </Col>
            <Col>
              <div className="reason-box">
                <div className="reason-title">Smart Campus</div>
                <p className="reason-desc">
                  50+ acre tech-enabled campus with top facilities.
                </p>
              </div>
            </Col>
            <Col>
              <div className="reason-box">
                <div className="reason-title">Global Exposure</div>
                <p className="reason-desc">
                  International partnerships and culturally diverse students.
                </p>
              </div>
            </Col>
            <Col>
              <div className="reason-box">
                <div className="reason-title">Top Placements</div>
                <p className="reason-desc">
                  Highest package ₹45 LPA, average ₹25 LPA offered.
                </p>
              </div>
            </Col>
            <Col>
              <div className="reason-box">
                <div className="reason-title">Industry Network</div>
                <p className="reason-desc">
                  Strong ties with IT, Finance, FMCG, and more.
                </p>
              </div>
            </Col>
            <Col>
              <div className="reason-box">
                <div className="reason-title">Modern Curriculum</div>
                <p className="reason-desc">
                  Courses aligned with industry and future skills.
                </p>
              </div>
            </Col>
          </div>
        </div>
      </section>

      {/* Campus Life */}
      <section className="ptb-50 color-section">
        <div className="container-xxl">
          <h2 className="section-title text-center modern-title w-75 mx-auto">
            Explore, Engage, and Embrace the Vibrant Spirit of Campus Life
          </h2>
          <h6 className="modern-subtitle text-center w-75 mx-auto">
            At ISBM University, we are committed to developing leaders who are
            not merely skilled professionals but also compassionate people with
            strong ethical values.
          </h6>

          <p>
            ISBM University is committed to encourage many ideas from diverse
            sources, creating a flower bed of entrepreneurship and start-ups. It
            also reflects the vision of ISBM University that wants to see
            thousands of youth opening their minds to new vistas and
            opportunities by using the power of knowledge, skills and incubation
            provided by ISBM University.
          </p>

          <Row className="row m-0 row-cols-lg-6 row-cols-md-5 row-cols-3 campus-container g-2">
            {campusItems.map((item, index) => (
              <Col>
                <div className="campus-box" key={index}>
                  <div className="campus-icon">
                    <img src={icons[index]} alt={item} />
                  </div>
                  <div className="campus-title">{item}</div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* Vibrant Campus  */}
      <section className="ptb-50">
        <div className="container-xxl">
          <h2 className="section-title-start modern-title mb-0">
            A Glimpse into Our
            <span className="main-header-content"> Vibrant Campus </span>Where
            Learning Meets Lifestyle
          </h2>
          <h6 class="modern-subtitle">
            At ISBM University, we are committed to developing leaders who are
            not merely skilled professionals but also compassionate people with
            strong ethical values.
          </h6>
          <p>
            ISBM University is committed to encourage many ideas from diverse
            sources, creating a flower bed of entrepreneurship and start-ups. It
            also reflects the vision of ISBM University that wants to see
            thousands of youth opening their minds to new vistas and
            opportunities by using the power of knowledge, skills and incubation
            provided by ISBM&nbsp;University.
          </p>

          <nav>
            <div class="nav nav-underline" id="nav-tab" role="tablist">
              <button
                class="nav-link active"
                id="nav-campus-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-campus"
                type="button"
                role="tab"
                aria-controls="nav-campus"
                aria-selected="true"
              >
                Campus
              </button>
              <button
                class="nav-link"
                id="nav-academics-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-academics"
                type="button"
                role="tab"
                aria-controls="nav-academics"
                aria-selected="false"
              >
                Academics
              </button>
              <button
                class="nav-link"
                id="nav-lab-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-lab"
                type="button"
                role="tab"
                aria-controls="nav-lab"
                aria-selected="false"
              >
                Laboratories
              </button>
              <button
                class="nav-link"
                id="nav-sports-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-sports"
                type="button"
                role="tab"
                aria-controls="nav-sports"
                aria-selected="false"
              >
                Sports
              </button>
              <button
                class="nav-link"
                id="nav-hostel-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-hostel"
                type="button"
                role="tab"
                aria-controls="nav-hostel"
                aria-selected="false"
              >
                Hostel
              </button>
              <button
                class="nav-link"
                id="nav-workshops-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-workshops"
                type="button"
                role="tab"
                aria-controls="nav-workshops"
                aria-selected="false"
              >
                Workshops
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-campus"
              role="tabpanel"
              aria-labelledby="nav-campus-tab"
              tabindex="0"
            >
              <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic1} className="gallery-image" alt="ISBM University campus building front view in Chhattisgarh" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic6} className="gallery-image" alt="Eco-friendly ISBM University campus with gardens and open space" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic3} className="gallery-image" alt="ISBM University Chhattisgarh campus with student bus" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={pic5} className="gallery-image" alt="ISBM University students enjoying campus environment in Chhattisgarh" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="gallery-row align-items-stretch mt-4 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={pic2} className="gallery-image" alt="ISBM University campus main building front view" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic4} className="gallery-image" alt="Green campus walkway at ISBM University" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic7} className="gallery-image" alt="ISBM University campus with green lawn and academic building" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic9} className="gallery-image" alt="Reception and waiting area inside ISBM University" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="gallery-row align-items-stretch mt-4 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic10} className="gallery-image" alt="Interior passage at ISBM University with classrooms" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic11} className="gallery-image" alt="ISBM University School of Pharmacy building front view" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic12} className="gallery-image" alt="Clean tiled corridor at ISBM University campus" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={pic14} className="gallery-image" alt="Green courtyard garden inside ISBM University campus" />
                      <div className="image-overlay">
                        <div className="overlay-content"></div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div
              class="tab-pane fade"
              id="nav-academics"
              role="tabpanel"
              aria-labelledby="nav-academics-tab"
              tabindex="0"
            >
              <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={acdpic1} className="gallery-image" alt="Modern library at ISBM University Raipur with academic books" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={acdpic2}
                            className="gallery-image" alt="ISBM University students studying together in campus library" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={acdpic3} className="gallery-image" alt="ISBM University Raipur moot court room setup for law students" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={acdpic4} className="gallery-image" alt="Reading Hall" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div
              class="tab-pane fade"
              id="nav-lab"
              role="tabpanel"
              aria-labelledby="nav-lab-tab"
              tabindex="0"
            >
              <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={labpic1} className="gallery-image" alt="ISBM University pharmacy students performing experiments in laboratory" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={labpic2}
                            className="gallery-image" alt="Practical training in pharmacology laboratory at ISBM University Raipur"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={labpic3} className="gallery-image" alt="ISBM University modern science laboratory with microscopes and equipment" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={labpic4} className="gallery-image" alt="ISBM University faculty guiding students in science laboratory with microscope" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={labpic8} className="gallery-image" alt="ISBM University Raipur laboratory with advanced pharmacy equipment" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={labpic5} className="gallery-image" alt="Students working in ISBM University computer lab" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={labpic6}
                            className="gallery-image" alt="Students Performing Chemistry Experiments in Laboratory"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={labpic7} className="gallery-image" alt="Biology Laboratory With Microscopes and Lab Equipment" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={labpic9} className="gallery-image" alt="ISBM University science department faculty teaching students in physics lab" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={labpic10}
                            className="gallery-image" alt="Students Learning Optics Experiment in Physics Laboratory"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={labpic11} className="gallery-image" alt="Isbm University Biology and Life Sciences Laboratory With Modern Equipment" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={labpic12} className="gallery-image" alt="Isbm University School of Pharmacy Laboratory With Instruments" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div
              class="tab-pane fade"
              id="nav-sports"
              role="tabpanel"
              aria-labelledby="nav-sports-tab"
              tabindex="0"
            >
              <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={sportspic1} className="gallery-image" alt="Students Playing Kabaddi on Campus Ground" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={sportspic2}
                            className="gallery-image" alt="Isbm University Students Playing Cricket on Campus Ground"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={sportspic3} className="gallery-image" alt="Students Enjoying Football Game at ISBM University" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={sportspic4} className="gallery-image" alt="ISBM University Students Playing Tennis on Campus Court" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={sportspic8} className="gallery-image" alt="Students Practicing Discus Throw on Sports Ground" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={sportspic5} className="gallery-image" alt="Students Practicing Shot Put on Athletics Ground" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={sportspic6}
                            className="gallery-image" alt="Students Playing Badminton in Campus Courtyard"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={sportspic7} className="gallery-image" alt="Students Playing Chess in Indoor Games Room" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={sportspic9} className="gallery-image" alt="Students and Faculty Enjoying Carrom in Indoor Sports Room" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={sportspic10}
                            className="gallery-image" alt="Students Playing Basketball on Campus Sports Court"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={sportspic11} className="gallery-image" alt="Students Running on Track" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={sportspic12} className="gallery-image" alt="Students Playing Volleyball on Campus" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div
              class="tab-pane fade"
              id="nav-hostel"
              role="tabpanel"
              aria-labelledby="nav-hostel-tab"
              tabindex="0"
            >
              <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={hostelpic1} className="gallery-image" alt="ISBM University Hostel Building" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={hostelpic2}
                            className="gallery-image" alt="ISBM University Campus Hostel"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={hostelpic3} className="gallery-image" alt="Hostel Room With Attached Washroom" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={hostelpic4} className="gallery-image" alt="Hostel Room" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={hostelpic8} className="gallery-image" alt="Students studying together in the central library" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={hostelpic5} className="gallery-image" alt="Comfortable two-bed hostel room for students" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={hostelpic6}
                            className="gallery-image" alt="ISBM University students enjoying meals in campus cafeteria"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={hostelpic7} className="gallery-image" alt="ISBM University gym with modern fitness equipment" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div
              class="tab-pane fade"
              id="nav-workshops"
              role="tabpanel"
              aria-labelledby="nav-workshops-tab"
              tabindex="0"
            >
              <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={workshopspic1} className="gallery-image" alt="ISBM University students performing practical training on industrial machine" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={workshopspic2}
                            className="gallery-image" alt="ISBM University engineering workshop with students and faculty guidance"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={workshopspic3} className="gallery-image" alt="Faculty guiding students on 3D printing machine" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={workshopspic4} className="gallery-image" alt="ISBM University civil engineering students practicing land surveying in lab" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={workshopspic8} className="gallery-image" alt="ISBM University engineering workshop with lab equipment" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={workshopspic5} className="gallery-image" alt="Engineering faculty guiding students in applied mechanics laboratory" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={workshopspic6}
                            className="gallery-image" alt="ISBM University Refrigeration and Air Conditioning Lab"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={workshopspic7} className="gallery-image" alt="Electrical and electronics engineering lab at ISBM University" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AboutUs;
